import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import core from './core'
import generic from '../modules/generic/store';
import special from '../modules/special/store'; 
import users from '../modules/users/store'; 
import teams from '../modules/teams/store'; 
import roles from '../modules/roles/store'; 
import roleperms from '../modules/roleperms/store'; 
import cfgtables from '../modules/cfgtables/store';
import cfgreftables from '../modules/cfgreftables/store';
import cfgmenus from '../modules/cfgmenus/store';
import cfgactions from '../modules/cfgactions/store';
import configs from '../modules/configs/store';
import abilityPlugin from './auth/ability'

Vue.use(Vuex)

export default new Vuex.Store({
	plugins: [
		abilityPlugin
	],
	modules: {
		auth,
		core,
		generic,
		special,
		cfgtables,
		cfgreftables,
		cfgmenus,
		cfgactions,
		configs,
		users,
		teams,
		roles,
		roleperms,
	} 
});
